<template>
  <body class="widget-box" style="height: 100vh !important;" v-if="open" id="changeBody">
    <div v-if="!showModal">
      <transition 
                  name="list"
                  mode="out-in"
                  class="timeline"
                  id="timeline">
        <div class="list-msg" style="float: left; display: flex; margin-top: 85px; word-break: break-all !important; white-space: normal;"
            v-if="(widgetData.newMsgCount < 1 && widgetData.newMsgCountBot < 1) && !showModal && widgetData.users.length > 0">
          <img class="img-icon" :style="{'filter': shadowStyle()}" :src="widgetData.users[iconNum].icon">
          <a class="new-msg-log" @click="clickModal();$store.dispatch('directtalk/setWDTSeeker', 0)"
              :style="{'background': color.iconBallon + '!important', 'color': color.iconMsg + '!important', 'filter': shadowStyle()}">{{ widgetData.welcomeMsg }}</a>
        </div>
      </transition>
      <!-- 一瞬飛び出す吹き出し -->
      <transition-group tag="div"
                        :name="tranName"
                        mode="out-in"
                        class="timeline"
                        >
        <div v-for="log in Logs" :key="log.id"
            class="list-msg" :class="'list-msg-'+log.id">
          <div style="float: left; display: flex; width: 100%;"
              v-if="(widgetData.newMsgCount > 0 || widgetData.newMsgCountBot > 0 || num > 0) && !showModal && Logs !== [] && log.msg.indexOf('[button]') === -1">
            <img class="img-icon" :style="{'filter': shadowStyle()}" :src="log.icon" v-if="log.icon!==''">
            <img class="img-icon" :style="{'filter': shadowStyle()}" src="../../assets/template/robot.png" v-else>
            <button class="msg-log button"
                    type="submit"
                    :style="{'background': color.iconBallon + '!important', 'color': color.iconMsg + '!important', 'filter': shadowStyle()}"
                    @click="clickModal();$store.dispatch('directtalk/setWDTSeeker', 0)">
              <div style="word-break: break-all !important; white-space: normal; width: 100%; font-size: 12px; padding: 5px;" v-if="log.msg.indexOf('[image]') == -1">{{ log.msg }}</div>
              <img style="margin-top: 5px; width: 100%; height: 70px; border-radius: 5px; object-fit: cover;" :src="log.image" v-if="log.image"/>
            </button>
          </div>
        </div>
      </transition-group>
      <div
          class="msg-ballon"
          v-if="tranName=='' && color.template == 10 && color.customMsg != ''"
          :style="{'background': color.iconBallon + '!important', 'color': color.iconMsg + '!important', 'filter': shadowStyle(), 'margin-right': '8px'}">
          <span>{{color.customMsg}}</span>
      </div>
    </div>
  </body>
</template>

<script>
import isJSON from '@/functions/isJSON'
import Worker from '@/worker/widget.worker'
import getIcon from '@/functions/getIcon'
import getAnimation from '@/functions/getAnimation'
import watchScenarioMixin from '@/mixins/watchScenarioMixin'
import { mapState } from 'vuex'
export default {
  name: 'ChatWidgetTimeline',
  componentName: 'ChatWidgetTimeline',
  mixins: [watchScenarioMixin],
  data () {
    return {
      viewType: 2,
      isDemo: false,
      weekday: [
        '日', '月', '火', '水', '木', '金', '土'
      ],
      menuActive: false,
      origin: null,
      source: null,
      once: true,
      Logs: [],
      num: 0,
      open: false,
      iconNum: 0,
      msgWait: 3000,
      isGetScenarioTable: false,
      isGetMessage: false,
      isOnly: false,
      cbName: '',
      botIndex: null,
      clickCount: 0,
      intervalId: undefined,
      tranName: '',
      pusedMessageNum: 0
    }
  },
  computed: {
    ...mapState('directtalk', ['seeker', 'data', 'widgetData', 'isMessageError', 'color', 'ws', 'isReconnect', 'showModal']),
    ...mapState('chatbot', ['scenario', 'scenarioTemp', 'minipk']),
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
    if (localStorage.getItem('MSG_' + this.seeker.id)) {
      localStorage.removeItem('MSG_' + this.seeker.id)
    }
  },
  created () {
    if (localStorage.getItem('ICON')) {
      localStorage.removeItem('ICON')
    }
  },
  mounted () {
    console.debug('*** Start *** mounted')
    var jsondata = null
    console.log('created() :' + location.host)
    document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
    window.addEventListener('message', (event) => {
      if (isJSON(event.data)) {
        jsondata = JSON.parse(event.data)
        setTimeout(() => {
          if (jsondata.referrer.indexOf(process.env.LOC_HOST + '/dashboard/directtalk') == -1 && jsondata.url !== null && jsondata.url !== undefined) {
            jsondata['isTimeLine'] = true
            this.$store.dispatch('directtalk/setJson', jsondata)
            console.info('called directtalk/setJson')
          }
        }, 1000)
        this.intervalId = setInterval(() => {
          // console.log(this.seeker)
          if (this.seeker.id) {
            // console.log(nowMessage)
            if (localStorage.getItem('ICON') === 'on') this.open = true
            // メッセージが来た場合
            let nowMessage = localStorage.getItem('MSG_' + this.seeker.id)
            if (nowMessage) {
              let nowMessageParse = JSON.parse(nowMessage)
              for (let i in nowMessageParse) {
                if (this.pusedMessageNum == i) {
                  // clientからのメッセージ送信時
                  this.pushLog(nowMessageParse[i].msg, nowMessageParse[i].icon, nowMessageParse[i].image)
                  this.pusedMessageNum++
                }
              }
            }
          }
        }, 1000)
      }
    }, false)
    console.debug('*** End *** mounted')
  },
  watch: {
    'seeker.id' () {
      this.$store.dispatch('directtalk/getRoomTemp')
    },
    'widgetData.isAuto' () {
      for (var i in this.widgetData.bots) {
        var urlAryS = this.widgetData.bots[i].start_url.split('|')
        for (var j in urlAryS) {
          if (urlAryS[j] === this.data.url) this.botIndex = this.widgetData.bots[i]
        }
      }
      if (this.widgetData.isAuto && this.widgetData.bots.length > 0 && this.botIndex) {
        this.$store.dispatch('chatbot/getScenarioOneTemp', { companyid: this.data.ckey, scenarioName: this.botIndex.scenario_name, node: 'INITIALIZE', rate: this.color.thinking_rate, minipk: this.botIndex.pk ? this.botIndex.pk : null})
      }
    },
    // scenarioTemp () {
    // 会話履歴のログを一瞬出す 訪問者会話のみ出す形に変更のため削除 戻す可能性あり
    //   this.pushLog(this.scenarioTemp.mainmessage, this.widgetData.bots[this.botIndex].icon, this.scenarioTemp.image)
    // },
  },
  methods: {
    pushLog (msg, icon, image) {
      console.debug('*** Start *** pushLog')
      console.debug('msg: ' + JSON.stringify(msg))
      console.debug('icon: ' + JSON.stringify(icon))
      console.debug('image: ' + JSON.stringify(image))
      this.num += 1
      var logIcon = null
      if (icon != null) logIcon = icon
      else logIcon = require('../../assets/template/robot.png')
      //checkboxシナリオのとき[checkbox][/checkbox]とlogiconが表示されないようにする
      if(msg !== '[checkbox][/checkbox]') {
        this.Logs.push({'id': this.num, 'icon': logIcon, 'msg': this.msgSubstring(msg), 'image': image})
        this.tranName = 'list'
        setTimeout(()=>{
          this.tranName = ''
        }, 10000)
      }
      console.debug('*** End *** pushLog')
    },
    msgSubstring (n) {
      console.debug('*** Start *** msgSubstring')
      console.debug('n: ' + JSON.stringify(n))
      console.debug('*** End *** msgSubstring')
      return this.messageCreate(n).length < 20 ? this.messageCreate(n) : this.messageCreate(n).substring(0, 20) + '...'
    },
    messageCreate (m) {
      console.debug('*** Start *** messageCreate')
      console.debug('m: ' + JSON.stringify(m))
      if (m.indexOf('[msg]') > -1) {
        var firstText = m.split('|')
        var text = firstText[0].replace('[msg]', '').replace('[/msg]', '')
        console.debug('*** End *** messageCreate')
        return text.split(',')[0]
      } else {
        console.info('[msg] <= -1')
        console.debug('*** End *** messageCreate')
        return m
      }
    },
    shadowStyle () {
      console.debug('*** Start *** shadowStyle')
      if (this.color.shadowType === 0) return 'drop-shadow(0px 0px 0px rgba(0,0,0,0.3))'
      else return 'drop-shadow(1px 1px 1px rgba(0,0,0,0.3))'
    },
    calcRightSpace () {
      if (this.color.iconWidth != undefined) {
        const icon_width = this.color.iconWidth.replace('px', '')
        const icon_exact_width = this.color.iconWidth.replace('px', '') * 0.8
        const shadow_width_one_side = (icon_width - icon_exact_width) / 2
        return shadow_width_one_side + 'px'
      }
    }
  },
}
</script>

<style lang="scss">
html {
  background-color:transparent !important;
  pointer-events:none;
  width: 100%;
  height: 100vh;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  overflow: hidden !important;
  -webkit-text-size-adjust: 100% !important;
  min-width: 0 !important;
}
body {
  background-color:transparent !important;
  position: fixed !important;
  width: 100%;
  height: 100vh !important;
  -webkit-text-size-adjust: 100% !important;
}
html::-webkit-scrollbar{
  display:none;
}
.timeline {
  margin-top: auto;
  height: auto;
  margin-top: 80px;
  max-height: 100px;
  overflow-y: hidden;
  pointer-events: auto !important;
}
.img-icon {
  height: 30px;
  width: 30px;
  margin-right: 5px;
  border-radius: 15px;
  background-color: white;
}
.new-msg-log {
  width: calc(100% - 40px);
  height: auto;
  background-color: #208CEB;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 10px;
  margin-bottom: 5px;
  color: white;
  padding: 10px;
  font-size: 12px;
  text-align: left;
  display: block;
  border: none;
  pointer-events: auto !important;
  z-index: 9999 !important;
}
.msg-log {
  width: calc(100% - 40px);
  height: auto;
  background-color: #208CEB;
  border-top-left-radius: 0;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-bottom: 5px;
  color: white;
  padding: 10px;
  font-size: 12px;
  text-align: left;
  display: block;
  border: none;
  pointer-events: auto !important;
  z-index: 9999 !important;
}
@media screen and (max-width: 300px) {
  .new-msg-log {
    padding: 7px;
    font-size: 11px;
  }
  .msg-log {
    width: calc(100% - 40px);
    height: auto;
    background-color: #208CEB;
    border-top-left-radius: 0;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    margin-bottom: 5px;
    color: white;
    padding: 7px;
    font-size: 12px;
    text-align: left;
    display: block;
    border: none;
    pointer-events: auto !important;
    z-index: 9999 !important;
  }
}
.list-msg {
  position: absolute;
  float: left;
  width: 100%;
  top: 0;
  pointer-events: auto !important;
  transform: scale(0) translateX(-500px);
}
.custom-icon-message {
  font-size: large;
  white-space: pre-wrap;
  &.-custom-true{
    position: absolute;
  }
}
.msg-ballon {
  word-break: break-all !important;
  white-space: pre-line;
  width: calc(100% - 50px);
  height: 60px;
  font-size: 12px;
  position: absolute;
  top: 0;
  right: 16px;
  margin-bottom: 5px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 0;
  font-size: 12px;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  font-weight: bold;
}
@for $i from 0 through 100 {
  $enter-delay: 300ms;
  .list-enter-active {
    opacity: 0;
    animation: fade-in 5s;
    &.list-msg-#{$i} {
      animation-delay: #{1250ms * $i};
    }
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
    transform: scale(0) translateX(300px);
  }
  20% {
    opacity: 1;
    transform: scale(1) translateX(0);
  }
  50% {
    opacity: 1;
    transform: scale(1) translateX(0);
  }
  80% {
    opacity: 1;
    transform: scale(1) translateX(0);
  }
  100% {
    opacity: 0;
    transform: scale(0) translateX(-500px);
  }
}
.welcome-msg-enter, .welcome-msg-enter-active {
  animation: welcome-msg-in .5s;
}
.welcome-msg-leave-to, .welcome-msg-leave-active {
  animation: welcome-msg-in .5s reverse;
}
@keyframes welcome-msg-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/ChatWidget/ChatWidgetTimeline.vue